export default{
  financeAndinsure:{
    Button:{
      lookDetail:"查看详情"
    },
    finance:{
      title:"金融服务",
      content:"金融服务平台利用产业优势与前沿科技，如AI、区块链等，打造真实贸易场景并沉淀供应链数据，以客观反映客户信用价值。平台联合潍坊银行、中信银行，提供包括农业普惠金融、国际结算、国际贸易融资、产业链金融、大数据信用在内的全面快捷金融服务，旨在降低企业融资成本，解决融资难题，促进产业链优化升级，助力企业与政府实现高效金融运作与产业发展。",
      bankList:[
        {name:"农业普惠金融",desc:"农业专属普惠金融，为农业小微企业和农户量身定制，以灵活的方案、贴心的服务，助力农业产业梦想蓬勃发展。",tel:"便企专线"},
        {name:"国际结算",desc:"以创新国际结算服务，破跨境交易难题，提资金流转效率，助企业扬帆世界。",tel:"便企专线"},
        {name:"国际贸易融资",desc:"以雄厚资金、灵活方案、专业风控，为跨境贸易赋能，开启全球财富新旅程。",tel:"便企专线"},
        {name:"贸E通",desc:"我行国际业务大集中系统，是业务操作与管理的核心枢纽。它处理国际业务操作，存储数据，自动生成函电、会计账，内嵌规章制度于风控机制，实现 “分散作业、集中管理” 模式。",tel:"便企专线"},
        {name:"产业链金融",desc:"深度洞察产业链运行逻辑，围绕核心企业，凭借先进金融科技，为上下游企业提供应收账款融资、订单融资、结算等综合服务，增强链上企业协同，稳固产业链生态。",tel:"便企专线"},
        {name:"大数据信用",desc:"依托先进技术，构建大数据信息业务体系。整合内外部海量数据，深度挖掘分析，赋能精准营销、智能风控、优化客户体验，为金融决策提供有力支撑，驱动业务创新与高质量发展。",tel:"便企专线"},
      ]
    },
    insure:{
      title:"保险服务",
      content:"保险服务作为专业金融服务，运用风险评估、预防和经济补偿等手段，为企业与个人提供全面风险保障。平台联合中国人民保险、中国出口信用保险等，提供包括国际保险、货运险、设施险、种植险在内的全面快捷保险服务，旨在协助识别、控制风险，将风险转移给保险公司，保障财务稳定，助力企业与政府实现高效运作与产业发展。",
      List:[
        {name:"信用保证保险",desc:"保障企业经营活动提供全面的全球贸易信用保证保险服务。"},
        {name:"短期出口信用保险",desc:"为以信用证、非信用证方式从中国出口的货物或服务提供应收账款收汇风险保障。"},
        {name:"中长期出口信用保险",desc:"为出口企业公司收回融资协议、商务合同或租赁协议项下应收款项提供风险保障。"},
        {name:"货物运输保险",desc:"建立全球理赔网络，能快速有效地提供检验、担保等服务。"},
        {name:"船舶保险",desc:"依托全球代理网络，为多家船队提供快速、优质、完善的专业化服务。"},
        {name:"航天航空保险",desc:"为航空公司、机场、通用航空运营商，以及其他航空相关风险提供一系列的保险保障。"},
        {name:"建筑工程保险",desc:"保障承建商就有关物业建筑、安装、装修、翻新或维修等提供综合全险服务。"},
        {name:"商业财产保险",desc:"保障因火灾、闪电、水湿、爆炸等意外所引致的财物损毁提供保险服务。"},
        {name:"商业性温室大棚及棚内农作物保险",desc:"保障农作物在生产或加工过程中发生约定的灾害事故承担赔偿责任的保险。"},
        {name:"马铃薯种植成本保险",desc:"为马铃薯种植提供全程保险服务。"},
        {name:"大豆种植成本保险",desc:"为大豆种植提供全程保险服务。"},
        {name:"小麦种植成本保险",desc:"为小麦种植提供全程保险服务。"},
      ],
      catgList:['国际保险','货运险','设施险','种植险']
    }
    
  }
  
}